import Swal from 'sweetalert2';
import { get_token } from "@/router";
import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';

export default {
mounted() {
  this.getProfileTypes();
  this.preview();
  this.get_question_types();
  this.fetchQuestions().then(() => {
      this.$nextTick(() => {
        $('.questionsTable').DataTable({
          paging: true,
          searching: true,
          ordering: true,
          info: true,
          lengthChange: true,
          pageLength: 10,
          language: {
            paginate: {
              previous: "Previous",
              next: "Next"
            },
            info: "Showing _START_ to _END_ of _TOTAL_ entries",
            infoEmpty: "No entries available"
          },
          sortColumn: '',
          sortDirection: 'asc'
        });
      });
    });
},
  data: () => ({
    questionDetails: [],
    token_exists: false,
    selectedQuestions: [],
  }),
  watch: {
    '$route.params.sections_id'() {
      this.assign_selected();
    }
  },
  components: {
    Sidebar,
    Navbar,
  },
  computed: {
    selected_items() {
      const map = new Map(this.questionDetails.map(q => [q.question_id, q]));
      return this.selectedQuestions.map(id => map.get(id)).filter(Boolean);
    },
    all_checked() {
      return this.questionDetails.length > 0 &&
            this.selectedQuestions.length === this.questionDetails.length;
    }
  },


  methods: {
    getToken() {
      return get_token();
    },

    getProfileTypes() {
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_profile_types/`,
        method: "GET",
        headers: { Authorization: `Token ${this.getToken()}` },
        success: (response) => {
          this.profileTypes = response.data;
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "Failed to load profile types",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }
      });
    },

    preview() {
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_questions/`,
        method: "POST",
        headers: this.token_exists
          ? { Authorization: `Token ${this.getToken()}` }
          : {},
        success: (response) => {
          const questionDetails = response.data.questions.map(question => ({
            question_id: question.id,
            question_name: question.question,
            question_type: question.question_type.question_type
          }));
          
          this.questionDetails = questionDetails;
          this.$nextTick(() => {
            if (this.dataTableInstance) {
              this.dataTableInstance.destroy();
              this.dataTableInstance = null;
            }
            this.dataTableInstance = $("#questionsTable").DataTable();
          });
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "Failed to load question types",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }
      });
    },
    toggle_all(evt) {
      if (evt.target.checked) {
        this.selectedQuestions = this.questionDetails.map(q => q.question_id);
      } else {
        this.selectedQuestions = [];
      }
    },

    remove_selected(question_id) {
      this.selectedQuestions = this.selectedQuestions.filter(id => id !== question_id);
    },


get_question_types() {
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_question_types/`,
        method: "GET",
        headers: { Authorization: `Token ${this.getToken()}` },
        success: (response) => {
          this.question_types = response.data.question_types;
        },
        error: () => {
          Swal.fire({
            icon: "error",
           title: "Failed to load question types",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }
      });
    },
    assign_selected() {
      const section_id = this.$route.params.section_id;
      if (!section_id) {
        Swal.fire({ icon: "warning", title: "No section selected" ,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
        });
        return;
      }
      if (this.selectedQuestions.length === 0) {
        Swal.fire({ icon: "info", title: "Select at least one question" ,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
        });
        return;
      }

      const payload = { question_ids: this.selectedQuestions, section_id };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/assign_questions/`,
        method: "POST",
        headers: {
          Authorization: `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        processData: false,
        success: (response) => {
          if (response.status === "success") {
            Swal.fire({
              icon: "success",
              title: "Questions submitted",
              text: "All questions have been submitted",
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            });
            this.selectedQuestions = [];
          }
        },
        error: () => Swal.fire({ icon: "error", title: "Failed to assign questions" ,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
        })
      });
    },

    fetchQuestions() {
      this.token_exists = get_token();
      return new Promise((resolve) => {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_questions/`,
          method: "POST",
          headers: {
            Authorization: `Token ${this.getToken()}`
          },
          success: (response) => {
            this.questions = response.data.questions;
            resolve();
          },
        });
      });
    }
  }
};

